import { render } from "./PartnerSelect.vue?vue&type=template&id=7037e4c7"
import script from "./PartnerSelect.vue?vue&type=script&lang=js"
export * from "./PartnerSelect.vue?vue&type=script&lang=js"
script.render = render

export default script